const state = {
  serInfo: {
    // iid: '2ec711408ef5460299c16ef6a12ea1b5',
    // schoolId:'fc8a'
  }, //登录后的用户信息
  token: '',
};
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
};

const actions = {
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  setUserInfo({ commit }, info) {
    commit('SET_USER_INFO', info)
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js